import React from 'react';

type FirstRunStep = 'profile' | 'workspace';

/**
 * Shared chrome for Clerk post-signup flows so `/complete-onboarding` and `/select-org`
 * feel like one continuous setup experience instead of unrelated full-page swaps.
 */
export const OperatorFirstRunShell: React.FC<{
  step: FirstRunStep;
  children: React.ReactNode;
}> = ({ step, children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-slate-900 text-slate-100">
      <header className="shrink-0 border-b border-slate-800 px-4 sm:px-6 py-3 flex flex-wrap items-center gap-3 gap-y-2">
        <img src="/HPMP.png" alt="" className="w-8 h-8 object-contain" width={32} height={32} />
        <div className="min-w-0">
          <p className="text-sm font-semibold text-white truncate">Hummingbird</p>
          <p className="text-xs text-slate-400">
            {step === 'profile' ? 'Finish your account' : 'Choose your workspace'}
          </p>
        </div>
        <nav className="ml-auto flex items-center gap-2 text-xs text-slate-500" aria-label="Setup progress">
          <span className={step === 'profile' ? 'text-brand-400 font-medium' : ''}>1 · Account</span>
          <span className="text-slate-600" aria-hidden>
            →
          </span>
          <span className={step === 'workspace' ? 'text-brand-400 font-medium' : ''}>2 · Workspace</span>
        </nav>
      </header>
      <div className="flex-1 min-h-0 flex flex-col">{children}</div>
    </div>
  );
};
